<template>
    <div>
        <v-card>
            <v-toolbar dark color="primary">
                <v-btn icon dark @click="close">
                    <v-icon>mdi-close</v-icon>
                </v-btn>
                <v-toolbar-title>{{ $t('notificationMap.title') }}</v-toolbar-title>
            </v-toolbar>
            <v-card-text>
                <div ref="pdfdiv">
                    <div style="width: 31%;height: 90vh;float: left;margin-top: 10px;
                    border-radius: 10px;background-color: #3a3b3c;overflow: auto;">
                        <v-container dark class="white--text" style="padding-left: 15px; padding-top: 20px">
                            <h1>{{ $t('notificationMap.details') }}</h1>
                            <br />
                            <hr style="border-top: 1px solid #fff" />
                            <pre>
    {{ $t('notificationMap.fields.plate') }}          : {{ vehicleMapSummary.plate }} </pre>
                            <pre>
    {{ $t('notificationMap.fields.orderNumber') }}    : {{ vehicleMapSummary.order }} </pre>
                            <pre>
    {{ $t('notificationMap.fields.vehicleCode') }}    : {{ vehicleMapSummary.code }} </pre>
                            <pre>
    {{ $t('notificationMap.fields.vehicleType') }}    : {{ vehicleMapSummary.type }} </pre>
                            <pre>
    {{ $t('notificationMap.fields.driver') }}         : {{ crewGuiaSummary.driver }} </pre>
                            <pre>
    {{ $t('notificationMap.fields.collector') }}      : {{ crewGuiaSummary.collector }} </pre>
                            <pre>
    {{ $t('notificationMap.fields.guideNumber') }}    : {{ crewGuiaSummary.guideNumber }} </pre>
                            <pre>
    {{ $t('notificationMap.fields.guideLine') }}     : {{ crewGuiaSummary.guideLine }} </pre>
                            <pre>
    {{ $t('notificationMap.fields.equipment') }}    : {{ itemMapaNotificacao.cod_equipamento }} </pre>
                            <pre>
    {{ $t('notificationMap.fields.notification') }}    : {{ itemMapaNotificacao.descricao_tipo_notificacao }} </pre>
                            <pre>
    {{ $t('notificationMap.fields.date') }}           : {{ itemMapaNotificacao.dt_notificacao_extenso }}</pre>
                            <pre>{{ $t('notificationMap.fields.lastPosition') }}   : {{ dtPosicaoNotificacao }} </pre>
                            <pre>{{ $t('notificationMap.fields.latitude') }}       : {{ latNotificacao }} </pre>
                            <pre>{{ $t('notificationMap.fields.longitude') }}      : {{ lngNotificacao }} </pre>
                            <br />
                            <div v-if="has_validador">
                                <h3>{{ $t('notificationMap.validador') }}</h3>
                                <hr style="border-top: 1px solid #fff" />
                                <pre>{{ $t('notificationMap.fields.driver') }}    :  {{ itemMapaNotificacao.matr_motorista_validador? `(${itemMapaNotificacao.matr_motorista_validador}) — ${itemMapaNotificacao.nome_motorista_validador}` : '—' }}</pre>
                                <pre>{{ $t('notificationMap.fields.collector') }}     :  {{ itemMapaNotificacao.matr_cobrador_validador? `(${itemMapaNotificacao.matr_cobrador_validador}) — ${itemMapaNotificacao.nome_cobrador_validador}` : '—' }}</pre>
                                <pre>{{ $t('notificationMap.fields.line') }}        :  {{ itemMapaNotificacao.nome_linha_validador? itemMapaNotificacao.nome_linha_validador : '—' }}</pre>
                                <pre>{{ $t('notificationMap.fields.shift') }}        :  {{ itemMapaNotificacao.turno_validador? itemMapaNotificacao.turno_validador : '—' }}</pre>
                            </div>
                            <br />
                            <h3>{{ $t('notificationMap.address') }}</h3>
                            <hr style="border-top: 1px solid #fff" />
                            <pre>{{ $t('notificationMap.fields.street') }}            :  {{ itemEndereco[0].street }}</pre>
                            <pre>{{ $t('notificationMap.fields.number') }}         :  {{ itemEndereco[0].houseNumber }}</pre>
                            <pre>{{ $t('notificationMap.fields.district') }}         :  {{ itemEndereco[0].district }}</pre>
                            <pre>{{ $t('notificationMap.fields.city') }}         :  {{ itemEndereco[0].city }}</pre>
                            <pre>{{ $t('notificationMap.fields.state') }}             :  {{ itemEndereco[0].stateCode }}</pre>
                            <pre>{{ $t('notificationMap.fields.zipCode') }}            :  {{ itemEndereco[0].postalCode }}</pre>

                            <hr style="border-top: 1px solid #fff" />
                            <br />
                            <v-btn color="primary" class="white--text" :disabled="this.togleBtnObterEndereco"
                                style="margin-left: 5px; margin-right: 5px" @click="
                                    obterEnderecoMarkerPlotagem(
                                        itemMapaNotificacao.lat,
                                        itemMapaNotificacao.lng,
                                        itemMapaNotificacao.id_notificacao
                                    )
                                    ">
                                {{ $t('notificationMap.getAddress') }}
                            </v-btn>

                            <v-progress-circular indeterminate v-if="showProgressoEndereco" color="primary"
                                style="margin-left: 20px"></v-progress-circular>
                        </v-container>
                    </div>
                    <div style="
                    width: 68%;
                    height: 90vh;
                    float: left;
                    margin-top: 10px;
                    margin-left: 3px;
                    border-radius: 10px;
                ">
                        <l-map ref="map" :zoom="zoom" :center="currentCenter" :minZoom="minZoom" :maxZoom="maxZoom"
                            @update:center="centerUpdate" @update:zoom="zoomUpdate" @ready="onMapResize"
                            :options="mapOptions" v-resize="onMapResize" style="border-radius: 10px">
                            <l-tile-layer :url="url" :attribution="attribution" />
                            <l-marker :lat-lng="latLng(this.latNotificacao, this.lngNotificacao)">
                                <l-popup :options="{ maxWidth: 'fit-content' }">
                                    <div v-if="has_validador" class="mapa-notificacao-popup-validador">
                                        <div><strong>{{ $t('notificationMap.fields.driver') }}</strong> {{itemMapaNotificacao.matr_motorista_validador? `(${itemMapaNotificacao.matr_motorista_validador}) — ${itemMapaNotificacao.nome_motorista_validador}` : '—' }}</div>
                                        <div><strong>{{ $t('notificationMap.fields.collector') }}</strong> {{itemMapaNotificacao.matr_cobrador_validador? `(${itemMapaNotificacao.matr_cobrador_validador}) — ${itemMapaNotificacao.nome_cobrador_validador}` : '—' }}</div>
                                        <div><strong>{{ $t('notificationMap.fields.line') }}</strong> {{ itemMapaNotificacao.nome_linha_validador? itemMapaNotificacao.nome_linha_validador : '—' }}</div>
                                        <div><strong>{{ $t('notificationMap.fields.shift') }}</strong> {{ itemMapaNotificacao.turno_validador? itemMapaNotificacao.turno_validador : '—' }}</div>
                                    </div>
                                    <div class="mapa-notificacao-popup-vehicle">
                                        <div><strong>{{ $t('notificationMap.fields.plate') }}</strong> {{ vehicleMapSummary.plate }}</div>
                                        <div><strong>{{ $t('notificationMap.fields.orderNumber') }}</strong> {{ vehicleMapSummary.order }}</div>
                                        <div><strong>{{ $t('notificationMap.fields.vehicleCode') }}</strong> {{ vehicleMapSummary.code }}</div>
                                        <div><strong>{{ $t('notificationMap.fields.vehicleType') }}</strong> {{ vehicleMapSummary.type }}</div>
                                    </div>
                                    <div class="mapa-notificacao-popup-crew">
                                        <div><strong>{{ $t('notificationMap.fields.driver') }}</strong> {{ crewGuiaSummary.driver }}</div>
                                        <div><strong>{{ $t('notificationMap.fields.collector') }}</strong> {{ crewGuiaSummary.collector }}</div>
                                        <div><strong>{{ $t('notificationMap.fields.guideNumber') }}</strong> {{ crewGuiaSummary.guideNumber }}</div>
                                        <div><strong>{{ $t('notificationMap.fields.guideLine') }}</strong> {{ crewGuiaSummary.guideLine }}</div>
                                    </div>
                                    <pre>{{ $t('notificationMap.fields.positionDate') }} : {{ dtPosicaoNotificacao }}</pre>
                                    <pre>{{ $t('notificationMap.fields.latitude') }}     : {{ latNotificacao }}</pre>
                                    <pre>{{ $t('notificationMap.fields.longitude') }}    : {{ lngNotificacao }}</pre>
                                </l-popup>
                            </l-marker>

                            <l-marker :key="j" v-for="(reg, j) in bilhetagens" :lat-lng="latLng(reg.lat, reg.lng)"
                                :visible="markerBilhetagensVisible" :icon="getIconBilhetagem()">
                                <l-popup :options="{ maxWidth: 'fit-content' }">
                                    <!-- <span v-html="reg.cod_veiculo"></span> -->
                                    <pre>{{ $t('notificationMap.fields.positionDate') }}      : {{ reg.dt_posicao_extenso }}</pre>
                                    <pre>{{ $t('notificationMap.fields.latitude') }}  : {{ reg.lat }}</pre>
                                    <pre>{{ $t('notificationMap.fields.longitude') }} : {{ reg.lng }}</pre>
                                </l-popup>
                            </l-marker>

                            <l-polygon :visible="showPolygonNotificacao" :lat-lngs="polygonNotificacoes.latlngs"
                                :color="polygonNotificacoes.color"></l-polygon>

                            <l-polyline :visible="showPolylineNotificacao" :lat-lngs="polylineNotificacoes.latlngs"
                                :color="polylineNotificacoes.color"></l-polyline>

                            <l-control :position="'topright'" class="text-overlay">
                                <v-row>
                                    <v-col cols="12" sm="6" md="3">
                                        <v-checkbox v-model="markerBilhetagensVisible"
                                            :label="$t('notificationMap.fields.ticketing')"></v-checkbox>
                                    </v-col>
                                </v-row>
                            </l-control>
                            <l-control :position="'topright'">
                                <v-btn small fab @click="exportPDF($refs.pdfdiv)">
                                    <v-icon color="black">mdi-file-pdf-box</v-icon></v-btn>
                            </l-control>
                        </l-map>
                    </div>
                </div>
            </v-card-text>
        </v-card>
    </div>
</template>

<script>
import apiController from '@/utils/apiController';
import L from "leaflet";
import {
    LMap,
    LTileLayer,
    LMarker,
    LPolyline,
    LPopup,
    LControl,
    LPolygon,
} from "vue2-leaflet";
import "leaflet/dist/leaflet.css";
import jsPDF from "jspdf";
import domtoimage from "dom-to-image";

export default {
    name: "MapaNotificacao",
    components: {
        LMap,
        LTileLayer,
        LMarker,
        LPolyline,
        LPopup,
        LControl,
        LPolygon,
    },
    props: {
        itemMapaNotificacao: {
            type: Object,
            required: true
        },
        user: {
            type: Object,
            required: true
        },
        token: {
            type: String,
            required: true
        },
        latNotificacao: {
            type: String
        },
        lngNotificacao: {
            type: String
        },
        itemEnderecoImport: {
            type: Object
        },
        dtPosicaoNotificacao: {
            type: String
        },
        bilhetagens: {
            type: Array
        },
        has_validador: {
            type: Boolean,
            default: true
        }
    },
    data: () => ({
        url: "https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png",
        attribution:
            '&copy; <a target="_blank" href="http://osm.org/copyright">OpenStreetMap</a> contributors',
        apikey: "FOvzDukk0SIaGv8RRFW50DQypjKr9HgD7hsV-S3NXFg",
        togleBtnObterEndereco: false,
        zoom: 16,
        currentZoom: 16,
        notificationFocusZoom: 16,
        // Must never be null: LMap/Leaflet throws before the map is ready.
        currentCenter: [-22.88746, -43.29185],
        minZoom: 5,
        maxZoom: 18,
        mapOptions: {
            zoomSnap: 0.5,
        },
        polylineNotificacoes: {
            latlngs: [],
            color: "red",
        },
        polygonNotificacoes: {
            latlngs: [],
            color: "blue",
        },
        markerBilhetagensVisible: false,
        showPolygonNotificacao: false,
        showPolylineNotificacao: false,
        platform: null,
        showProgressoEndereco: false,
        itemEndereco: [
            {
                street: "",
                houseNumber: "",
                district: "",
                city: "",
                stateCode: "",
                postalCode: "",
            }],
    }),
    created() {
        this.applyNotificationCenter();
    },
    mounted() {
        const platform = new window.H.service.Platform({
            apikey: this.apikey,
        });
        this.platform = platform;
        this.initialize();
        this.$nextTick(() => {
            this.focusMapOnNotification();
            setTimeout(() => this.focusMapOnNotification(), 200);
        });
    },
    watch: {
        latNotificacao() {
            this.applyNotificationCenter();
        },
        lngNotificacao() {
            this.applyNotificationCenter();
        },
    },
    computed: {
        center() {
            return this.$store.getters['config/centerDefault'];
        },
        vehicleMapSummary() {
            const it = this.itemMapaNotificacao || {};
            const dash = '—';
            const text = (v) => {
                if (v == null) return dash;
                const s = String(v).trim();
                return s === '' ? dash : s;
            };
            const order = it.numero_ordem;
            const orderStr =
                order != null && order !== '' && String(order).trim() !== ''
                    ? String(order)
                    : dash;
            return {
                plate: text(it.placa),
                order: orderStr,
                code: text(it.cod_veiculo),
                type: text(it.descricao_tipo_veiculo),
            };
        },
        crewGuiaSummary() {
            const it = this.itemMapaNotificacao || {};
            const dash = '—';
            const text = (v) => {
                if (v == null) return dash;
                const s = String(v).trim();
                return s === '' ? dash : s;
            };
            const ng = it.numero_guia;
            const guideNum =
                ng != null && ng !== '' && String(ng).trim() !== ''
                    ? String(ng)
                    : dash;
            return {
                driver: text(it.nome_motorista_guia),
                collector: text(it.nome_cobrador_guia),
                guideNumber: guideNum,
                guideLine: text(it.nome_linha_guia),
            };
        },
    },
    methods: {
        parseNotificationCoords(lat, lng) {
            const la = Number(lat);
            const ln = Number(lng);
            if (!Number.isFinite(la) || !Number.isFinite(ln)) return null;
            if (la === 0 && ln === 0) return null;
            if (Math.abs(la) > 90 || Math.abs(ln) > 180) return null;
            return [la, ln];
        },
        applyCenterFromStore() {
            const c = this.center;
            if (
                Array.isArray(c) &&
                c.length === 2 &&
                c[0] != null &&
                c[1] != null
            ) {
                const lat = Number(c[0]);
                const lng = Number(c[1]);
                if (!Number.isNaN(lat) && !Number.isNaN(lng)) {
                    this.currentCenter = [lat, lng];
                    return;
                }
            }
            this.currentCenter = [-22.88746, -43.29185];
        },
        applyNotificationCenter() {
            const coords = this.parseNotificationCoords(
                this.latNotificacao,
                this.lngNotificacao
            );
            if (coords) {
                this.currentCenter = coords;
                this.zoom = this.notificationFocusZoom;
                this.currentZoom = this.notificationFocusZoom;
                return;
            }
            this.applyCenterFromStore();
        },
        focusMapOnNotification() {
            const coords = this.parseNotificationCoords(
                this.latNotificacao,
                this.lngNotificacao
            );
            if (!coords) return;
            this.$nextTick(() => {
                const map = this.$refs.map && this.$refs.map.mapObject;
                if (map && map.setView) {
                    map.setView(coords, this.notificationFocusZoom);
                }
            });
        },
        initialize() {
            this.applyNotificationCenter();
            if (this.itemEnderecoImport) {
                this.itemEndereco = [this.itemEnderecoImport];
            }
        },
        async exportPDF(div) {
            this.mensagemProgressoDialog = this.$t('notificationMap.messages.exportingPDF');
            this.progressoDialog = true;
            await domtoimage
                .toPng(div)
                .then(function (dataUrl) {
                    var img = new Image(800, 400);
                    img.src = dataUrl;
                    const doc = new jsPDF({
                        orientation: "l",
                        //unit: "cm",
                        //format: [300, 700],
                        format: "a4",
                    });
                    doc.addImage(img, "JPEG", 5, 5, 285, 195);
                    const date = new Date();
                    const filename =
                        "plotagem_" +
                        date.getFullYear() +
                        ("0" + (date.getMonth() + 1)).slice(-2) +
                        ("0" + date.getDate()).slice(-2) +
                        ("0" + date.getHours()).slice(-2) +
                        ("0" + date.getMinutes()).slice(-2) +
                        ("0" + date.getSeconds()).slice(-2) +
                        ".pdf";
                    doc.save(filename);
                })
                .catch(function (error) {
                    console.error("oops, something went wrong!", error);
                });
            this.mensagemProgressoDialog = "";
            this.progressoDialog = false;
        },
        updateEnderecoNotificacao(id) {
            apiController.request(apiController.endpoints.updateEndereconotificacao, {
                data: {
                    id_notificacao: id,
                    endereco: this.itemEndereco,
                },
                silent: true,
                onSuccess: () => { },
                onError: (e) => {
                    console.log("Response : " + e.message);
                    if (e.message == "Request failed with status code 401") {
                        this.mensagemAutorizacaoDialog = e.response.data.mensagem;
                        this.autorizacaoDialog = true;
                    }
                }
            });
        },
        obterEnderecoMarkerPlotagem(lat, lng, idnotificacao) {
            this.showProgressEndereco = true;
            var service = this.platform.getSearchService();

            service.reverseGeocode(
                {
                    at: lat + "," + lng,
                },
                (result) => {
                    const item = result.items[0].address;
                    this.itemEndereco = [];
                    this.itemEndereco.push({
                        street: item.street,
                        houseNumber: item.houseNumber,
                        district: item.district,
                        city: item.city,
                        stateCode: item.stateCode,
                        postalCode: item.postalCode,
                    });
                    if (idnotificacao != null) {
                        this.updateEnderecoNotificacao(idnotificacao);
                        this.$emit('enderecoAtualizado', this.itemEndereco[0]);
                    }
                    this.showProgressoEndereco = false;
                },
                (error) => {
                    console.log(error);
                    this.itemEndereco = [
                        {
                            street: "",
                            houseNumber: "",
                            district: "",
                            city: "",
                            stateCode: "",
                            postalCode: "",
                        }];
                    this.mensagemAutorizacaoDialog =
                        this.$t('notificationMap.messages.noAddressFound');
                    this.autorizacaoDialog = true;
                    this.showProgressEndereco = false;
                }
            );
        },
        zoomUpdate(zoom) {
            this.currentZoom = zoom;
        },
        centerUpdate(center) {
            this.currentCenter = center;
        },
        onMapResize() {
            this.$nextTick(() => {
                const map = this.$refs.map && this.$refs.map.mapObject;
                if (map && map.invalidateSize) {
                    map.invalidateSize();
                }
                this.focusMapOnNotification();
            });
        },
        getIconBilhetagem() {
            return L.divIcon({
                className: "my-custom-pin",
                html: '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="20px" height="32px"><title>Bilhetagem</title><path fill="#FF0000" d="M21.1,12.5L22.5,13.91L15.97,20.5L12.5,17L13.9,15.59L15.97,17.67L21.1,12.5M10,17L13,20H3V18C3,15.79 6.58,14 11,14L12.89,14.11L10,17M11,4A4,4 0 0,1 15,8A4,4 0 0,1 11,12A4,4 0 0,1 7,8A4,4 0 0,1 11,4Z" /></svg>',
            });
        },
        latLng(lat, lng) {
            const coords = this.parseNotificationCoords(lat, lng);
            if (coords) {
                return L.latLng(coords[0], coords[1]);
            }
            return L.latLng(-22.88746, -43.29185);
        },
        close() {
            this.$emit('close');
        },
    }
}
</script>

<style>
.mapa-notificacao-vehicle-panel {
    background: rgba(255, 255, 255, 0.96);
    border-radius: 8px;
    box-shadow: 0 2px 10px rgba(0, 0, 0, 0.22);
    padding: 10px 14px;
    min-width: 210px;
    max-width: 300px;
    font-size: 13px;
    line-height: 1.45;
    color: #333;
}
.mapa-notificacao-vehicle-panel__title {
    font-weight: 600;
    color: #1565c0;
    margin-bottom: 8px;
    font-size: 14px;
    border-bottom: 1px solid #e0e0e0;
    padding-bottom: 6px;
}
.mapa-notificacao-vehicle-panel__title--secondary {
    margin-top: 10px;
    margin-bottom: 6px;
    padding-top: 8px;
    border-top: 1px solid #e0e0e0;
    border-bottom: 1px solid #e0e0e0;
}
.mapa-notificacao-vehicle-panel__row {
    display: flex;
    justify-content: space-between;
    align-items: baseline;
    gap: 12px;
    margin-top: 5px;
}
.mapa-notificacao-vehicle-panel__label {
    color: #616161;
    flex-shrink: 0;
}
.mapa-notificacao-vehicle-panel__value {
    font-weight: 600;
    text-align: right;
    word-break: break-word;
}
.mapa-notificacao-popup-vehicle {
    margin-bottom: 8px;
    padding-bottom: 8px;
    border-bottom: 1px solid #e0e0e0;
    font-size: 12px;
    line-height: 1.5;
}
.mapa-notificacao-popup-vehicle div {
    margin-bottom: 2px;
}
.mapa-notificacao-popup-crew {
    margin-bottom: 8px;
    padding-bottom: 8px;
    border-bottom: 1px solid #e0e0e0;
    font-size: 12px;
    line-height: 1.5;
}
.mapa-notificacao-popup-crew div {
    margin-bottom: 2px;
}
.mapa-notificacao-popup-validador {
    margin-bottom: 8px;
    padding-bottom: 8px;
    border-bottom: 1px solid #e0e0e0;
    font-size: 12px;
    line-height: 1.5;
}
.mapa-notificacao-popup-validador div {
    margin-bottom: 2px;
}
</style>